import { Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, Typography } from '@mui/material';

import Button from 'domains/core/components/Button';

export type AffectedReference = {
    changedSendName: string;
    referencingSendName: string;
};

type Props = {
    affected: AffectedReference[];
    confirmButtonText: string;
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const SplitRewireConfirmDialog = ({ affected, confirmButtonText, open, onCancel, onConfirm }: Props) => (
    <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={onCancel}
        aria-modal="true"
        data-testid="split-rewire-confirm-dialog"
    >
        <DialogTitle>Saving will update a conditional split</DialogTitle>
        <DialogContent>
            <Typography variant="body1" gutterBottom>
                The following activity filters reference a send whose content has changed. Saving will automatically
                rewire them to track the updated version.
            </Typography>
            <List dense disablePadding>
                {affected.map((ref, i) => (
                    <ListItem key={i} disableGutters>
                        <Typography variant="body2" data-testid="split-rewire-affected-item">
                            <strong>{ref.referencingSendName}</strong> uses <strong>{ref.changedSendName}</strong> as an
                            activity filter.
                        </Typography>
                    </ListItem>
                ))}
            </List>
        </DialogContent>
        <DialogActions>
            <Button variant="text" onClick={onCancel} data-testid="split-rewire-cancel-button">
                Cancel
            </Button>
            <Button variant="contained" onClick={onConfirm} data-testid="split-rewire-confirm-button">
                {confirmButtonText}
            </Button>
        </DialogActions>
    </Dialog>
);

export default SplitRewireConfirmDialog;
